import { ImageDimensionsInput } from '@deltek/specification-client/core/Models/imageDimensionsInput'
import { ProjectParameter } from '@deltek/specification-client/core/Models/projectParameter'
import { suffixDimension } from '@deltek/specification-client/core/Utilities/stringUtils'

export const baseProjectImageUrl = `${process.env.REACT_APP_CdnBaseUrl}/specpoint/global/project-default-images`

export const cardProjectImageDimension: Partial<ImageDimensionsInput> = {
    width: 475,
    height: 163,
}

export const projectOverviewImageDimension: Partial<ImageDimensionsInput> = {
    width: 950,
    height: 325,
}

export interface DetermineProjectImageProps {
    imageUrl: string | undefined | null
    parameters: Partial<ProjectParameter>[] | undefined
    imageDimension: Partial<ImageDimensionsInput>
    defaultImage?: string
}
export const determineProjectImage = ({
    imageUrl,
    parameters,
    imageDimension,
    defaultImage,
}: DetermineProjectImageProps) => {
    const image = !!imageUrl
        ? imageUrl
        : getDefaultImageUrlByProjectParameter(parameters!)

    return !!image
        ? suffixDimension({
              filename: image!,
              dimension: imageDimension,
          })
        : defaultImage
}

const getBuildingTypeParamter = (parameters: Partial<ProjectParameter>[]) => {
    const parameter = parameters?.find(
        (each) => each.modifierList?.name === 'Building Type'
    )
    if (!!parameter) return parameter.selectedModifiers?.[0]?.name
    return ''
}

const getDefaultImageUrlByProjectParameter = (
    parameters: Partial<ProjectParameter>[]
) => {
    switch (getBuildingTypeParamter(parameters)?.toLocaleLowerCase().trim()) {
        case 'airports and runways':
            return `${baseProjectImageUrl}/Airports_and_Runways.jpg`
        case 'automotive facility':
            return `${baseProjectImageUrl}/Automotive_Facility.jpg`
        case 'convention center':
            return `${baseProjectImageUrl}/Convention_Center.jpg`
        case 'courthouse':
            return `${baseProjectImageUrl}/Courthouse.jpg`
        case 'data center':
        case 'data center - shell':
        case 'data center - suites':
            return `${baseProjectImageUrl}/Data_Center.jpg`
        case 'dining cafeteria fast food':
            return `${baseProjectImageUrl}/Dining_Cafeteria_Fast_Food.jpg`
        case 'dining bar lounge or leisure':
            return `${baseProjectImageUrl}/Dining_Bar_Lounge_or_Leisure.jpg`
        case 'dining family':
            return `${baseProjectImageUrl}/Dining_Family.jpg`
        case 'dormitory':
            return `${baseProjectImageUrl}/Dormitory.jpg`
        case 'exercise center':
            return `${baseProjectImageUrl}/Exercise_Center.jpg`
        case 'fire station':
            return `${baseProjectImageUrl}/Fire_Station.jpg`
        case 'gymnasium':
            return `${baseProjectImageUrl}/Gymnasium.jpg`
        case 'hospital or healthcare':
            return `${baseProjectImageUrl}/Hospital_or_Healthcare.jpg`
        case 'hotel':
            return `${baseProjectImageUrl}/Hotel.jpg`
        case 'laboratory':
            return `${baseProjectImageUrl}/Laboratory.jpg`
        case 'library':
            return `${baseProjectImageUrl}/Library.jpg`
        case 'manufacturing':
            return `${baseProjectImageUrl}/Manufacturing.jpg`
        case 'mixed use':
            return `${baseProjectImageUrl}/Mixed_Use.jpg`
        case 'motel':
            return `${baseProjectImageUrl}/Motel.jpg`
        case 'motion picture theatre':
            return `${baseProjectImageUrl}/Motion_Picture_Theatre.jpg`
        case 'multi family':
            return `${baseProjectImageUrl}/Multi_Family.jpg`
        case 'museum':
            return `${baseProjectImageUrl}/Museum.jpg`
        case 'office':
            return `${baseProjectImageUrl}/Office.jpg`
        case 'parking garage':
            return `${baseProjectImageUrl}/Parking_Garage.jpg`
        case 'penitentiary':
            return `${baseProjectImageUrl}/Penitentiary.jpg`
        case 'performing arts theater':
            return `${baseProjectImageUrl}/Performing_Arts_Theater.jpg`
        case 'police station':
            return `${baseProjectImageUrl}/Police_Station.jpg`
        case 'post office':
            return `${baseProjectImageUrl}/Post_Office.jpg`
        case 'rail and transit systems':
            return `${baseProjectImageUrl}/Rail_and_Transit_Systems.jpg`
        case 'religious building':
            return `${baseProjectImageUrl}/Religious_Building.jpg`
        case 'roads, highways, and bridges':
            return `${baseProjectImageUrl}/Roads_Highways_and_Bridges.jpg`
        case 'retail':
            return `${baseProjectImageUrl}/Retail.jpg`
        case 'school or university':
            return `${baseProjectImageUrl}/School_or_University.jpg`
        case 'schools (k-12)':
            return `${baseProjectImageUrl}/Schools_K12.jpg`
        case 'single family':
            return `${baseProjectImageUrl}/Single_Family.jpg`
        case 'sports arena':
            return `${baseProjectImageUrl}/Sports_Arena.jpg`
        case 'town hall':
            return `${baseProjectImageUrl}/Town_Hall.jpg`
        case 'transportation':
            return `${baseProjectImageUrl}/Transportation.jpg`
        case 'universities':
            return `${baseProjectImageUrl}/Universities.jpg`
        case 'utility and pipeline infrastructure':
            return `${baseProjectImageUrl}/Utility_and_Pipeline_Infrastructure.jpg`
        case 'warehouse':
            return `${baseProjectImageUrl}/Warehouse.jpg`
        case 'water and wastewater treatment plants':
            return `${baseProjectImageUrl}/Water_and_Wastewater_Treatment_Plants.jpg`
        case 'workshop':
            return `${baseProjectImageUrl}/Workshop.jpg`
    }
}
